import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { getProductListColumns } from './productListColumns';

import type { TypeProduct } from '~/types/product.types';

/**
 * [운영 상품 조회] 페이지 > 테이블 컬럼 정의
 */
const getProductOperatingColumnDefs = ({ onClickViewDetail }: { onClickViewDetail: (skuCode: string) => void }) => {
  const columnDefs: TypeTableColumn<TypeProduct>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    ...getProductListColumns({ onClickViewDetail }),
  ];

  return { columnDefs };
};

export default getProductOperatingColumnDefs;
